import { GET_PROFILE_DETAILS } from './types';


export const getProfileDetailsAction = (profileDetails) => dispatch => {
    dispatch({
        type: GET_PROFILE_DETAILS,
        profileDetails: profileDetails,
    })

}
